import './App.css';
import Header from './components/Header/Header';
import './Image/body.png'
import Poets from './components/Poets/Poets';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <div className="App">
      <div className="container">
      <Header></Header>
      <Poets></Poets>
      <Footer></Footer>
      </div>
    </div>
  );
}

export default App;